module.exports = __webpack_public_path__ + "img/Title_New.807b5faa.jpeg";